<template>
	<v-app>
		<v-container fluid fill-height>
			<v-layout align-center justify-center>
				<div class="text-md-center">
					<h1 class="ma-5">Zatwierdź zmianę adresu e-mail</h1>
					<v-text-field
						browser-autocomplete="off"
						name="Hasło"
						label="Hasło"
						aria-label="password"
						for="change-user-password"
						id="change-user-password"
						v-model="formData.password"
						data-vv-name="password"
						data-vv-as="Hasło"
						:type="showPassword? 'text' : 'password'"
						:append-icon="showPassword? 'visibility' : 'visibility_off'"
						@click:append="showPassword = !showPassword"
						:error-messages="vErrors.collect('password')"
						@click="disableErrorMessage"
						v-validate="'required'"
					></v-text-field>
					<v-expand-transition>
						<div v-show="showErrorMessage" style="color: red">
							{{errorMessage}}
						</div>
					</v-expand-transition>
					<div>
						<v-btn color="primary" @click="setUpEmail">Zatwierdź</v-btn>
					</div>
				</div>
			</v-layout>
		</v-container>
	</v-app>
</template>

<script>
	import {Credentials} from "@/api/generated/Credentials";

	export default {
		name: "ChangeUserEmailView",

		data () {
			return {
				formData: {
					password: "",
					token: "",
				},

				showErrorMessage: false,

				errorMessage: '',

				showPassword: false
			};
		},

		methods: {
			disableErrorMessage () {
				this.showErrorMessage = false;
			},

			setUpEmail () {
				this.$validator.validateAll().then((result) => {
					if (!result) return;
					Credentials.putSetupUserEmail(this, this.formData, () => {
							sessionStorage.removeItem("access_token");
							sessionStorage.removeItem("role");
							this.$router.push("/setup-email-confirmed");
						},
						errorResponse => {
							this.errorMessage = errorResponse.errors[0];
							this.showErrorMessage = true;
						});
				});
			}
		},

		beforeMount () {
			this.formData.token = this.$route.query.token;
			Credentials.getUserExistsByEmailToken(this, this.formData.token, response => {
				if (response.status !== "OK") {
					this.$router.push("/not-found");
				}
			});
		},
	};
</script>

<style scoped>

</style>